import { ref, computed, watch } from "vue";
import { windowReload } from "~/utils/miscellaneous";
import centralEventBus from "~/lib/centralEventBus";
import getEnvironmentConfig, {
  envKeys,
  mockEnvKey,
  getVueEnvConfig,
  getHostEnv,
} from "~/lib/envSelector/envSource";
import merge from "lodash/merge";

const COMMON_ENV_SELECTOR_PARAMS = {
  defaultEnv: "dev",
  localStorageKey: "lastSelectedEnv",
};

const SET_ENVIRONMENTS_FROM_LOCATION_HOST = ["dev", "uat"];

const mockEnv = ref(mockEnvKey);
const mockVueEnvConfig = computed(() => getVueEnvConfig(mockEnv.value));
const isEnabled = ref(process.env.VUE_APP_ENABLE_ENV_SELECTOR == "true");
const allEnv = ref(
  envKeys.filter(
    (env) => !(process.env.NODE_ENV != "development" && env == "local")
  )
);

class EnvSelector {
  constructor(defaultEnv, localStorageKey) {
    this._selectedEnv = ref(localStorage.getItem(localStorageKey));
    watch(this._selectedEnv, (env) =>
      localStorage.setItem(localStorageKey, env)
    );
    this._defaultEnv = defaultEnv;
    this._localStorageKey = localStorageKey;
    const environmentConfig = computed(() =>
      getEnvironmentConfig(this._selectedEnv.value)
    );
    this._envSelectorData = {
      isEnabled,
      allEnv,
      selectedEnv: this._selectedEnv,
      selectedHostEnvConfig: computed(() => environmentConfig.value.hostEnv),
      selectedVueEnvConfig: computed(() => environmentConfig.value.vueEnv),
      hostEnv: computed(() => getHostEnv()),
      mockEnv,
      mockVueEnvConfig,
      isMockEnabled: computed(() => this._selectedEnv.value == mockEnv.value),
    };
  }

  setEnvironment(app) {
    const envSelectorObj = this.getEnvSelectorObj(app);
    const lastSelectedEnv = envSelectorObj.selectedEnv.value;
    const isSelectedEnvValid =
      envSelectorObj.allEnv.value.indexOf(lastSelectedEnv) != -1;

    if (!envSelectorObj.isEnabled.value) {
      if (!lastSelectedEnv)
        envSelectorObj.selectedEnv.value =
          this.getEnvironmentFromLocationHost() || "prod";
      else if (!isSelectedEnvValid)
        console.error(
          `From localStorage with key '${
            this._localStorageKey
          }' got an invalid environment '${lastSelectedEnv}', valid environments are ${envSelectorObj.allEnv.value.join(
            ","
          )}`
        );
    } else if (!lastSelectedEnv || !isSelectedEnvValid) {
      envSelectorObj.selectedEnv.value = this._defaultEnv;
    }

    return envSelectorObj;
  }

  getEnvironmentFromLocationHost() {
    let hostFirstPart = window.location.hostname.split(".")[0];

    return SET_ENVIRONMENTS_FROM_LOCATION_HOST.find((includeStr) =>
      hostFirstPart.includes(includeStr)
    );
  }

  _onChangeEnv(env) {
    if (!env || this.envSelector._selectedEnv.value == env) return;

    this.envSelector._selectedEnv.value = env;
    centralEventBus.$emit("vuexPersistClearStorage");
    windowReload.call(this.app, "root");
  }

  getEnvSelectorObj(app) {
    let changeEnv = this._onChangeEnv.bind({ envSelector: this, app });
    return merge({ changeEnv }, this._envSelectorData);
  }
}

export default new EnvSelector(
  COMMON_ENV_SELECTOR_PARAMS.defaultEnv,
  COMMON_ENV_SELECTOR_PARAMS.localStorageKey
);